import { Component, Prop, Vue } from 'vue-property-decorator';
const Grid = require('../grid/grid.vue.html');
import HearingService from '../../services/HearingService';

@Component({
    components: {
        Grid
    }
})
export default class Search extends Vue {
    searchDialog: Boolean = true;
    searchValue: string = '';
    gridTitle: string = 'Search Results';
    results: any = { data: [], headers: [] };
    isValid: boolean = true;
    searchOptions: Array<any> = [{ text: 'Claim #', value: '', id: 'claimNumber' }, { text: 'Policy #', value: '', id: 'policyNumber' },
    { text: 'Employer Name', value: '', id: 'employerName' }, { text: 'Claimant Name', placeholder: 'LastName, FirstName', value: '', id: 'claimantName' }];

    public service = new HearingService();

    placeholder(item: any) {
        return item.placeholder ? item.placeholder : item.text;
    }

    mounted() {
        this.searchOptions = this.$store.getters.existingSearchCriteria;
        this.results = this.$store.getters.existingSearchResults;
    }

    search() {
        this.results.data = null;
        this.results.headers = null;
        let searchObj: any = {};

        this.isValid = this.searchOptions.some((item: any, index: number) => { return item.value != ''; });

        if (this.isValid) {
            this.searchOptions.forEach((item: any, indx: number) => {
                searchObj[item.id] = item.value;
            });

            this.service.SearchHearing(searchObj)
                .then((resp) => {
                    this.results = resp;

                    //store search options and results
                    let searchObj = { options: this.searchOptions, results: this.results };
                    this.$store.dispatch('setSearchCriteria', searchObj);
                    this.$store.dispatch("isLoading", false);
                })
        }
    }

    clear() {
        this.$store.dispatch('clearSearchCriteria');
        this.results.data = null;
        this.results.headers = null;
        this.isValid = true;
        this.searchOptions.every((item: any, index: number) => {
            item.value = '';
            return true;
        })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/components/search/search.ts